/* @flow */

export default class CreateCouponRequest {
  isoCompanyId: number;
  companyId: number;
  value: number;
  reason: string;
}